import VisibilityIcon from "@mui/icons-material/Visibility";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

const ClientDetailsTableRow = ({
  id,
  image,
  name,
  country,
  notes,
  screener,
  sessions,
  type,
  worksheets,
  onClickCallback,
  onReschedule,
  onAddNote,
  onPrescription,
  onCancel,
  onAddSessionNote,
}) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    if (onClickCallback) {
      onClickCallback(
        name,
        id,
        image,
        country,
        notes,
        screener,
        sessions,
        type,
        worksheets
      );
    }
  };

  const onChat = () => {
    navigate(`/expert/chat?clientID=${id}&clientName=${name}&type=redirect`);
  };

  const onCourseUnderTaken = () => {
    navigate(`/expert/clients?client=${name}&id=${id}&tabIndex=4`);
  };

  return (
    <TableRow
      className={`ClientDetails--TableRow`}
      sx={{
        backgroundColor: "#FFF",
        "&:last-child td, &:last-child th": { border: 0 },
      }}
    >
      <TableCell>
        <img
          src={image}
          width={45}
          height={45}
          style={{
            borderRadius: "50%",
            objectFit: "cover",
            objectPosition: "top",
          }}
        />
      </TableCell>
      <TableCell className="Table--Name">
        <div>
          <p>{name}</p>
          <span>{country}</span>
        </div>
      </TableCell>

      <TableCell className="Table--Sessions">
        <p>{sessions}</p>
      </TableCell>

      <TableCell className="Table--SessionNotes">
        <p>{notes}</p>
      </TableCell>

      <TableCell className="Table--Worksheets">
        <p>{worksheets}</p>
      </TableCell>
      {/* <TableCell align="right">
        <div className="Table--Actions d-flex">
          <Button onClick={handleRowClick}>
            <VisibilityIcon />
            <p>View</p>
          </Button>

          <Button onClick={onChat}>
            <ChatBubbleOutlineOutlinedIcon />
            <p>Chat</p>
          </Button>

          <Button
            id="demo-positioned-button"
            aria-controls={open ? "demo-positioned-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <ArrowDropDownOutlinedIcon />
          </Button>

          <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            className="DarkDropdown"
          >
            <MenuItem sx={{ fontSize: "14px" }} onClick={onAddNote}>
              Add Note
            </MenuItem>
            <Divider />
            <MenuItem sx={{ fontSize: "14px" }} onClick={onAddSessionNote}>
              Add Session Note
            </MenuItem>
            <MenuItem sx={{ fontSize: "14px" }} onClick={onCourseUnderTaken}>Courses Undertaken</MenuItem>
          </Menu>
        </div>
      </TableCell> */}
      <TableCell>
        <div
          style={{
            display: "flex",
            gap: "12px",
            alignItems: "center",
            justifyContent: "flex-end",
            margin: 0,
            padding: 0,
          }}
        >
          <Button
            onClick={handleRowClick}
            size="small"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              textTransform: "none",
              color: "#414141",
              backgroundColor: "#fafafa",
              padding: "6px 12px",
              borderRadius: "50px",
              fontSize: "13px",
              fontWeight: 500,
              margin: 0,
              minWidth: "auto",
            }}
          >
            <VisibilityIcon fontSize="small" />
            <span>View</span>
          </Button>

          {/* <Button onClick={onChat}>
            <ChatBubbleOutlineOutlinedIcon />
            <p>Chat</p>
          </Button> */}

          <Button
            onClick={onChat}
            size="small"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              textTransform: "none",
              color: "#414141",
              backgroundColor: "#fafafa",
              padding: "6px 12px",
              borderRadius: "50px",
              fontSize: "13px",
              fontWeight: 500,
              margin: 0,
              minWidth: "auto",
            }}
          >
            <ChatBubbleOutlineOutlinedIcon fontSize="small" />
            <span>Chat</span>
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
};

export default ClientDetailsTableRow;
